export default __webpack_public_path__ + "static/media/git.81533a6b.png";